import { render, staticRenderFns } from "./SJXBack.vue?vue&type=template&id=2e93ccd2&scoped=true&"
import script from "./SJXBack.vue?vue&type=script&lang=js&"
export * from "./SJXBack.vue?vue&type=script&lang=js&"
import style0 from "./SJXBack.vue?vue&type=style&index=0&id=2e93ccd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93ccd2",
  null
  
)

export default component.exports